'use strict';
import classNames from 'classnames';
import * as T from 'prop-types';
import React from 'react';
import {UserChannelList} from '../../../comments/components/UserChannelList';
import {I18nMessage} from '../../../components/I18nMessage';
import {UserLayout} from '../../../components/views/UserLayout';
import {UserViewChannelsFilter} from './UserViewChannelsFilter';


export function UserViewChannelsView(props) {
  return (
    <UserLayout
      className={classNames("UserViewChannels", props.className)}
      title={<I18nMessage message="user.views.chat.label" />}
      filterComponent={(
        <UserViewChannelsFilter />
      )}
      mode={props.mode}
      onLoadMore={props.onLoadMore}
    >
      <UserChannelList
        transitionGroupClass="UserLayout__content__container"
        itemClassName="UserLayout__content__item"
        useScroll={false}
        list={props.list}
        mode={props.mode}
        userId={props.userId}
        onLoadMore={props.onLoadMore}
        onShowChat={props.onShowChat}
        onRemoveConversation={props.onRemoveConversation}
        onAccessError={props.onAccessError}
        onItemContextMenu={props.onItemContextMenu}

        init={props.init}
      />
    </UserLayout>
  );
}

UserViewChannelsView.propTypes = {
  className: T.string,

  init: T.bool,
};

UserViewChannelsView.defaultProps = {
  init: true,
};



// WEBPACK FOOTER //
// ./src/js/user/components/UserViewChannels/UserViewChannelsView.js